import { Link } from 'gatsby';
import React, { useMemo } from 'react';
import { ArticleContentfulModel } from 'src/api/models/ArticleGroup';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import ResourceCenterArticle from './resourceCenter.article';
import { ArticleGroup, ArticleGroupContainer, ArticleGroupWrapper, ArticleLinkContainer } from './article.group.styles';
import { convertResourceCategoryToPageSlug } from 'src/functions/resouceCategoryToSlug';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';

export interface ResourceCenterArticleGroupProps {
  articleGroup: ArticleContentfulModel,
  index?: number
}

const ResourceCenterArticleGroup = ({ articleGroup, index }: ResourceCenterArticleGroupProps): JSX.Element => {

  const articleCategoty = useMemo(() => {
    // Only show View All to article groups with only one category
    const distinctCategories = [ ...new Set(articleGroup.articleGroup.map(item => item.category)) ];
    return distinctCategories.length === 1 ? convertResourceCategoryToPageSlug(distinctCategories[0]) : null;
  }, [ articleGroup ]);

  return (
    <ArticleGroupWrapper index={index}>
      <ArticleGroupContainer>
        <FadeInAnimationWrapper>
          <Heading
            text={articleGroup.title}
            size="2.5em"
            sizeMd="2em"
            sizeSm="1.85em"
            align="center"
          />
        </FadeInAnimationWrapper>
        <FadeInAnimationWrapper>
          <Paragraph
            text={articleGroup.description}
            size="1.375em"
            sizeSm="1.15em"
            align="center"
            weight="light"
          />
        </FadeInAnimationWrapper>
        <ArticleGroup>
          {articleGroup.articleGroup.filter(_article => _article.heroImage?.gatsbyImageData).filter((_article, index) => index < 3).map((article) => (
            <FadeInAnimationWrapper key={article.id}>
              <ResourceCenterArticle article={article} previewDescription  />
            </FadeInAnimationWrapper>
          ))}
        </ArticleGroup>
        <ArticleLinkContainer>
          {
            articleCategoty && (
              <FadeInAnimationWrapper>
                <Link to={`/resources/${articleCategoty}`}>
                  View All
                </Link>
              </FadeInAnimationWrapper>
            )
          }
        </ArticleLinkContainer>
      </ArticleGroupContainer>
    </ArticleGroupWrapper>

  )
}

export default ResourceCenterArticleGroup;
